module.exports = __webpack_public_path__ + "img/incubus_small.93fbe348.png";